module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0016-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev249"
    }
  }, [_vm._v("THE MULE.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("THIS useful and hardy animal is the offspring of the Horse and the Ass, and being generally barren, furnishes an indisputable proof that the two species are perfectly distinct. Nature has providently stopped the further propagation of these heterogeneous productions, to preserve, uncontaminated, the form of each animal; without which regulation, the races would in a short time be mixed with each other, and every creature, losing its original perfection, would rapidly degenerate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mules have not unfrequently been known to bring forth young, especially in hot countries; and instances have not been wanting, though they are rare, both in England and Scotland. But it would require a succession of experiments to prove that Mules will breed with each other, and produce an offspring equally capable of continuing the race.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The common Mule is very healthy, and will live above thirty years. It is found very serviceable in ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("carrying burdens, particularly in mountainous and stony places, where horses are not so sure-footed. The size and strength of our breed have lately been much improved by the importation of Spanish male Asses; and it were much to be wished, that the useful qualities of this animal were more attended to: for, by proper care in its breaking, its natural obstinacy would in a great measure be corrected; and it might be formed with success for the saddle, the draught, or the burden.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("People of the first quality in Spain are drawn by Mules, where fifty or sixty guineas is no uncommon price for one of them; nor is it surprising, when we consider how far they excel the Horse in travelling in a mountainous country, the Mule being able to tread securely where the former can hardly stand. Their manner of going down the precipices of the Alps, the Andes, &c., is very extraordinary; and with it we will conclude their history. In these passages, on one side, are steep eminences, and, on the other, frightful abysses; and as they generally follow the direction of the mountain, the road, instead of lying on a level, forms, at every little distance, deep declivities, of several hundred yards downward. These can be descended only by Mules; and the animal itself seems sensible of the danger, and the caution that is to be used in such descents. When they come to the edge of one of these precipices, they stop without being checked by the rider; and if he inadvertently attempt to spur them on, they continue immoveable. They seem all this time ruminating on the danger that lies before them, and preparing themselves for the encounter. They not only attentively ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("view the road, but tremble and snort at the danger. Having prepared for the descent, they place their fore feet in a posture as if they were stopping themselves; they then also put their hind feet together, but a little forward, as if they were going to lie down. In this attitude, having taken as it were a survey of the road, they slide down with the swiftness of a meteor. In the mean time, all the rider has to do is to keep himself fast on the saddle, without checking the rein, for the least motion is sufficient to disorder the equilibrium of the Mule; in which case they both unavoidably perish. But their address in this rapid descent is truly wonderful; for in their swiftest motion, when they seem to have lost all government of themselves, they follow exactly the different windings of the road, as if they had previously settled in their minds the route they were to follow, and taken every precaution for their safety. In this journey, the natives place themselves along the sides of the mountains; and, holding by the roots of the trees, animate the beasts with shouts, and encourage them to persevere. Some Mules, after being long used to these journies, acquire a kind of reputation for their safety and skill; and their value rises in proportion to their fame.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0018-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37aac10c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_16_ch8.vue
// module id = 99
// module chunks = 0